







import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import CardList from '@/components/card/CardList.vue'

@Component({
  components: {
    CardList,
  },
  computed: {},
})
export default class Card extends Vue {
  get labelBreadcrumb(): string {
    return this.$t('breadcrumb.card_info_manage') as string
  }
}
